import service from '@/store/services/workshop/procurement_order-service';

const state = {
  list: {},
  procurement_order: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, procurement_order) => {
    state.procurement_order = procurement_order;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  },
  
  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  },

  input_payment({commit, dispatch}, params) {
    return service.input_payment(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  },

  input_invoice({commit, dispatch}, params) {
    return service.input_invoice(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  },


  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((procurement_order) => { commit('SET_RESOURCE', procurement_order); });
  }

  
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  procurement_order: state => state.procurement_order,
  page: state => state.meta.page,

};
 
const procurement_order = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default procurement_order;
